import ComponentName from '@Constant/componentName'

const crowd = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/wechat.game',
    redirect: {
      name: ComponentName.wechatGame.index
    },
    children: [
      {
        component: () => import('../../views/wechat-game/index'),
        path: 'index',
        name: ComponentName.wechatGame.index,
        auth: '*',
        meta: {
          title: '微信小程序'
        }
      }
    ]
  }
]

export default crowd
